module.exports = __webpack_public_path__ + "media/ab-homepage/app-builder-desktop-e3504bea.png";